(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["mcb-volume-discount-block"] && !Shopify.designMode) return;
  try {
    /**
     * @typedef {Object} DiscountTier
     * @property {number} quantity - Required quantity for this tier
     * @property {number} discount - Discount percentage (0-100)
     */
  
    /**
     * @typedef {Object} DiscountConfig
     * @property {DiscountTier[]} tiers - Array of discount tiers
     * @property {string} blockId - Block identifier
     */
  
    /**
     * @typedef {Object} VariantData
     * @property {number} id - Variant ID
     * @property {number} price - Variant price in cents
     * @property {boolean} available - Whether variant is available
     * @property {string|null} inventory_management - Inventory management setting
     * @property {string} inventory_policy - Inventory policy ('continue' or 'deny')
     * @property {number|null} inventory_quantity - Available stock quantity
     */
  
    if (!customElements.get('volume-pricing')) {
      window.customElements.define(
        'volume-pricing',
        class VolumePricing extends HTMLElement {
          constructor() {
            super();
            
            // Bind handlers so we can remove them later
            this.boundHandleVariantChange = this.handleVariantChange.bind(this);
            this.boundHandleTierClick = this.handleTierClick.bind(this);
            this.boundHandleTierKeydown = this.handleTierKeydown.bind(this);
            
            // Track which element has the variant change listener
            this.variantChangeTarget = null;
            
            // Store tier event listener references for cleanup
            this.tierListeners = new Map();
            
            // Flag to prevent handleVariantChange from auto-selecting when user manually selects
            this.userSelectedTier = false;
            
            // Track previous variant's discount state to prevent unnecessary hiding/showing
            this.previousVariantHasDiscounts = null;
          }
          
          // Debug utility function
          debugLog(message, data = null) {
            if (this.debug) {
              if (data !== null) {
                console.log('[Volume Discount]', message, data);
              } else {
                console.log('[Volume Discount]', message);
              }
            }
          }
          
          debugWarn(message, data = null) {
            if (this.debug) {
              if (data !== null) {
                console.warn('[Volume Discount]', message, data);
              } else {
                console.warn('[Volume Discount]', message);
              }
            }
          }
          
          debugError(message, data = null) {
            if (this.debug) {
              if (data !== null) {
                console.error('[Volume Discount]', message, data);
              } else {
                console.error('[Volume Discount]', message);
              }
            }
          }
          
          connectedCallback() {
            // Initialize when element is connected to DOM
            this.tiers = this.querySelectorAll('.volume-pricing-tier');
            this.section = this.closest('.js-product');
            this.sectionId = this.dataset.sectionId;
            this.debug = this.dataset.debug === 'true';
            
            this.init();
            
            /**
             * Listen for variant changes - try section first, fallback to document
             * The 'on:variant:change' event is dispatched by the variant-picker component
             * when a customer selects a different variant. We listen on the section first
             * for better performance, but fall back to document-level listening if needed.
             */
            if (this.section) {
              this.section.addEventListener('on:variant:change', this.boundHandleVariantChange);
              this.variantChangeTarget = this.section;
              this.debugLog('Event listener attached to section:', this.section);
            } else {
              // Fallback: listen on document if section not found (for pages with different structure)
              document.addEventListener('on:variant:change', this.boundHandleVariantChange);
              this.variantChangeTarget = document;
              this.debugWarn('Section not found, listening on document');
            }
          }
        
        
          async init() {
            this.debugLog('Component initialized:', {
              tierCount: this.tiers.length,
              sectionId: this.sectionId,
              sectionFound: !!this.section,
            });
            
            for (const tier of this.tiers) {
              // Store bound handlers for cleanup
              const clickHandler = this.boundHandleTierClick;
              const keydownHandler = this.boundHandleTierKeydown;
              
              tier.addEventListener('click', clickHandler);
              tier.addEventListener('keydown', keydownHandler);
              
              this.debugLog('Added event listeners to tier', {
                tier,
                quantity: tier.dataset.quantity,
                hasClickHandler: !!clickHandler
              });
              
              // Store references for cleanup
              this.tierListeners.set(tier, {
                click: clickHandler,
                keydown: keydownHandler
              });
            }
            
            // Check initial variant on page load
            // Wait for variant-picker custom element to be defined, then check after DOM is ready
            if (!customElements.get('variant-picker')) {
              await customElements.whenDefined('variant-picker');
            }
            
            // Use requestAnimationFrame to ensure DOM is fully ready
            requestAnimationFrame(() => {
              this.checkInitialVariant();
            });
            
            if (this.tiers.length > 0) {
              this.selectTier(this.tiers[0]);
            }
            
            if (this.debug && this.section) {
              console.log('[Volume Discount] Variant change listener attached to section');
            }
          }
          
          /**
           * Check the initial variant when the page loads
           * 
           * This handles cases where a variant is pre-selected via URL parameter (e.g., ?variant=123).
           * Without this check, the volume discount block might not update correctly on initial page load
           * if a variant is already selected (either via URL or as the default variant).
           * 
           * We create a synthetic event to reuse the handleVariantChange logic, ensuring consistency.
           */
          checkInitialVariant() {
            // Try to get current variant from variant-picker (works with both selector types)
            let variantPicker = this.section?.querySelector('variant-picker');
            if (!variantPicker) {
              variantPicker = this.closest('.js-product')?.querySelector('variant-picker');
            }
            if (!variantPicker) {
              variantPicker = document.querySelector('variant-picker');
            }
            
            if (variantPicker && variantPicker.variant) {
              const currentVariant = variantPicker.variant;
              this.debugLog('Checking initial variant:', currentVariant.id);
              // Create a synthetic event to reuse handleVariantChange logic
              const syntheticEvent = {
                detail: {
                  variant: currentVariant,
                  allVariants: variantPicker.data?.variants || []
                }
              };
              this.handleVariantChange(syntheticEvent);
            } else {
              // Fallback: try to get variant from URL parameter
              const urlParams = new URLSearchParams(window.location.search);
              const variantId = urlParams.get('variant');
              if (variantId) {
                // Try to find variant in variant-picker data
                if (variantPicker && variantPicker.data && variantPicker.data.variants) {
                  const variant = variantPicker.data.variants.find(v => v && v.id == variantId);
                  if (variant) {
                    this.debugLog('Found initial variant from URL:', variant.id);
                    const syntheticEvent = {
                      detail: {
                        variant: variant,
                        allVariants: variantPicker.data.variants
                      }
                    };
                    this.handleVariantChange(syntheticEvent);
                  }
                }
              }
            }
          }
          
          /**
           * Helper method to find the quantity input element
           * Tries multiple selector patterns to support different Shopify themes
           * @returns {HTMLInputElement|null} The quantity input element or null if not found
           */
          findQuantityInput() {
            const sectionId = this.dataset.sectionId;
            let quantityInput = null;
            
            if (sectionId) {
              quantityInput = document.querySelector(`#Quantity-${sectionId}`);
            }
            if (!quantityInput) {
              quantityInput = document.querySelector('#quantity');
            }
            if (!quantityInput) {
              quantityInput = document.querySelector('input[name="quantity"]');
            }
            
            return quantityInput;
          }
          
          /**
           * Cleanup method called when element is removed from DOM
           */
          disconnectedCallback() {
            // Remove variant change listener
            if (this.variantChangeTarget && this.boundHandleVariantChange) {
              this.variantChangeTarget.removeEventListener('on:variant:change', this.boundHandleVariantChange);
              this.debugLog('Removed variant change listener from', 
                this.variantChangeTarget === document ? 'document' : 'section');
            }
            
            // Remove tier event listeners
            for (const [tier, handlers] of this.tierListeners.entries()) {
              tier.removeEventListener('click', handlers.click);
              tier.removeEventListener('keydown', handlers.keydown);
            }
            
            // Clear the map
            this.tierListeners.clear();
            
            this.debugLog('Component disconnected and cleaned up');
          }
          
          /**
           * Handles variant change events and updates tier visibility and prices
           * @param {CustomEvent} evt - Variant change event
           */
          async handleVariantChange(evt) {
            this.debugLog('handleVariantChange called', {
              hasEvent: !!evt,
              hasDetail: !!evt?.detail,
              hasVariant: !!evt?.detail?.variant,
              variantId: evt?.detail?.variant?.id
            });
            
            if (!evt.detail.variant) {
              this.debugWarn('Variant change event missing variant data');
              return;
            }
            
            const variant = evt.detail.variant;
            this.debugLog('Variant changed:', {
              id: variant.id,
              price: variant.price,
              available: variant.available,
              inventory_quantity: variant.inventory_quantity,
              inventory_management: variant.inventory_management,
              inventory_policy: variant.inventory_policy
            });
            
            const container = this.closest('.volume-pricing-container');
            if (!container) {
              this.debugWarn('Container not found');
              return;
            }
            
            // Get discount config from JSON script tag
            const configScript = container.querySelector('[data-volume-discount-config]');
            if (!configScript) {
              if (this.debug) {
                console.warn('[Volume Discount] Config script tag not found');
              }
              return;
            }
            
            let config;
            try {
              config = JSON.parse(configScript.textContent);
            } catch (error) {
              if (this.debug) {
                console.error('[Volume Discount] Error parsing discount config:', error);
                console.error('[Volume Discount] Config script content:', configScript.textContent);
              }
              return;
            }
            
            // Consolidated single debug log for all metafield information (only when debug is enabled)
            const debugScript = container.querySelector('[data-volume-discount-debug]');
            if (debugScript) {
              try {
                const debugInfo = JSON.parse(debugScript.textContent);
                const rawMetafield = config.discountKitData?.volumeDiscountKeys;
                const tiers = rawMetafield?.config?.value?.tiers || [];
                
                // Enhanced debugging for fixed amount discount interpretation
                const fixedAmountAnalysis = tiers.map(tier => {
                  if (tier.gets?.type === 'fixedAmount' || rawMetafield?.reward_type === 'FIXED_AMOUNT') {
                    const buysQty = tier.buys?.value || 0;
                    const getsValue = tier.gets?.value || 0;
                    return {
                      quantity: buysQty,
                      getsValue: getsValue,
                      getsValueFormatted: (getsValue / 100).toFixed(2) + ' EUR',
                      interpretation: {
                        perItem: `€${(getsValue / 100).toFixed(2)} per item`,
                        ifTotal: buysQty > 0 ? `€${(getsValue / buysQty / 100).toFixed(2)} per item (if total)` : 'N/A',
                        note: 'Discount Kit stores fixed amount discounts. Check if value is per-item or total by comparing with admin configuration.'
                      }
                    };
                  }
                  return null;
                }).filter(Boolean);
                
                // Extract all discount names for easy identification in Discount Kit admin
                const allDiscountNames = {
                  product: (debugInfo.productDiscountsInfo || []).map(d => ({
                    title: d.title,
                    rewardType: d.rewardType,
                    tierCount: d.tierCount,
                    tiers: d.tiers
                  })),
                  collection: (debugInfo.collectionDiscountsInfo || []).map(d => ({
                    title: d.title,
                    rewardType: d.rewardType,
                    tierCount: d.tierCount,
                    tiers: d.tiers
                  })),
                  shop: (debugInfo.shopDiscountsInfo || []).map(d => ({
                    title: d.title,
                    rewardType: d.rewardType,
                    tierCount: d.tierCount,
                    tiers: d.tiers
                  }))
                };
                
                // Always log this critical info (not just when debug is enabled) to help diagnose discount selection issues
                const debugOutput = {
                  ...debugInfo,
                  metafieldData: {
                    configTiersStructure: config.configTiersStructure,
                    rawMetafield: rawMetafield,
                    rewardType: config.discountKitData?.rewardType,
                    tiers: tiers,
                    fixedAmountAnalysis: fixedAmountAnalysis.length > 0 ? fixedAmountAnalysis : null,
                    selectedDiscountTiers: debugInfo.selectedDiscount?.tiers || debugInfo.selectedDiscountTiers || [],
                    discountSource: debugInfo.discountSource || debugInfo.selectedDiscount?.source,
                    selectedDiscountTitle: debugInfo.selectedDiscount?.discountTitle || debugInfo.selectedDiscount
                  },
                  allDiscountNames: allDiscountNames,
                  selectedDiscountInfo: {
                    title: debugInfo.selectedDiscount?.discountTitle || debugInfo.selectedDiscount,
                    source: debugInfo.discountSource || debugInfo.selectedDiscount?.source,
                    rewardType: debugInfo.selectedDiscount?.rewardType || debugInfo.selectedDiscountRewardType,
                    tiers: debugInfo.selectedDiscountTiers || debugInfo.selectedDiscount?.tiers || []
                  },
                  issue: tiers.length === 1 && tiers[0]?.buys?.value === 3 && tiers[0]?.gets?.value === 1600
                    ? '⚠️ Only tier 3 found in metafield, but admin shows discount for quantity 2. Possible issues: 1) Discount Kit only stores highest tier, 2) Wrong discount selected, 3) Discount configuration mismatch'
                    : null
                };
                
                // Always log discount names (even if debug is off) to help identify which discount is selected
                console.log('📊 [Volume Discount] All Discount Names:', {
                  selected: {
                    title: debugOutput.selectedDiscountInfo.title,
                    source: debugOutput.selectedDiscountInfo.source,
                    rewardType: debugOutput.selectedDiscountInfo.rewardType,
                    tiers: debugOutput.selectedDiscountInfo.tiers
                  },
                  available: {
                    product: allDiscountNames.product.map(d => d.title),
                    collection: allDiscountNames.collection.map(d => d.title),
                    shop: allDiscountNames.shop.map(d => d.title)
                  },
                  counts: {
                    product: debugInfo.productDiscountsCount || 0,
                    collection: debugInfo.collectionDiscountsCount || 0,
                    shop: debugInfo.shopDiscountsCount || 0
                  }
                });
                
                if (this.debug) {
                  if (debugInfo.rawShopMetafield != null) {
                    console.log('1️⃣ [Volume Discount] Store (shop) raw Discount Kit metafield:', debugInfo.rawShopMetafield);
                  } else {
                    console.log('1️⃣ [Volume Discount] Store (shop) raw Discount Kit metafield: null');
                  }
                  if (debugInfo.rawCollectionMetafield != null) {
                    console.log('2️⃣ [Volume Discount] Collection raw Discount Kit metafield:', debugInfo.rawCollectionMetafield);
                  } else {
                    console.log('2️⃣ [Volume Discount] Collection raw Discount Kit metafield: null');
                  }
                  if (debugInfo.rawProductMetafield != null) {
                    console.log('3️⃣ [Volume Discount] Product raw Discount Kit metafield:', debugInfo.rawProductMetafield);
                  } else {
                    console.log('3️⃣ [Volume Discount] Product raw Discount Kit metafield: null');
                  }
                  console.log('📊 [Volume Discount] Full Debug Info:', debugOutput);
                } else {
                  // Even if debug is off, log if there's a potential issue
                  if (debugOutput.issue) {
                    console.warn('📊 [Volume Discount] Potential Issue Detected:', debugOutput);
                  }
                }
              } catch (e) {
                if (this.debug) {
                  console.warn('[Volume Discount] Failed to parse debug info:', e);
                }
              }
            }
            
            // Get variant picker for inventory and variant data
            // Try multiple locations to find variant-picker (works with both radio button and dropdown selectors)
            let variantPicker = this.section?.querySelector('variant-picker');
            if (!variantPicker) {
              // Fallback: search from container
              variantPicker = container.closest('.js-product')?.querySelector('variant-picker');
            }
            if (!variantPicker) {
              // Fallback: search from document (for pages with different structure)
              variantPicker = document.querySelector('variant-picker');
            }
            
            // Check if variant is available - if not, hide entire block via Alpine
            if (variant.available === false) {
              // Only update Alpine if this is a change from a variant with discounts
              if (this.previousVariantHasDiscounts === true) {
                if (window.Alpine && container) {
                  const alpineData = Alpine.$data(container);
                  if (alpineData) {
                    alpineData.hasDiscounts = false;
                  }
                }
              }
              this.previousVariantHasDiscounts = false;
              return;
            }
            
            // Don't show container yet - we'll show it only after confirming variant has discounts
            
            // Get inventory info from variant
            // Try to get from allVariants array first (most reliable - full variant data from JSON)
            let fullVariant = null;
            if (evt.detail.allVariants && Array.isArray(evt.detail.allVariants)) {
              fullVariant = evt.detail.allVariants.find(v => v && v.id === variant.id);
            }
            
            // Also try to get from variant-picker's data object (has full variant data from JSON script tag)
            // The variant-picker's JSON includes all variant properties including inventory_policy
            // This works with both radio button and dropdown variant selectors
            let variantPickerVariant = null;
            if (variantPicker) {
              // Try to get data from variant-picker's parsed data object
              if (variantPicker.data && variantPicker.data.variants) {
                variantPickerVariant = variantPicker.data.variants.find(v => v && v.id === variant.id);
              }
              // If data object not available yet, try parsing the JSON script tag directly
              if (!variantPickerVariant) {
                const jsonScript = variantPicker.querySelector('script[type="application/json"]');
                if (jsonScript) {
                  try {
                    const variantData = JSON.parse(jsonScript.textContent);
                    if (variantData.variants && Array.isArray(variantData.variants)) {
                      variantPickerVariant = variantData.variants.find(v => v && v.id === variant.id);
                    }
                  } catch (error) {
                    if (this.debug) {
                      console.warn('[Volume Discount] Error parsing variant-picker JSON:', error);
                    }
                  }
                }
              }
            } else {
              // Fallback: try to find variant-picker JSON script tag anywhere in the document
              // This helps when variant-picker element isn't found but the JSON data exists
              if (this.debug) {
                console.log('[Volume Discount] Variant-picker not found, searching for JSON script tag');
              }
              const allJsonScripts = document.querySelectorAll('variant-picker script[type="application/json"]');
              for (const jsonScript of allJsonScripts) {
                try {
                  const variantData = JSON.parse(jsonScript.textContent);
                  if (variantData.variants && Array.isArray(variantData.variants)) {
                    variantPickerVariant = variantData.variants.find(v => v && v.id === variant.id);
                    if (variantPickerVariant) {
                      if (this.debug) {
                        console.log('[Volume Discount] Found variant data from JSON script tag');
                      }
                      break;
                    }
                  }
                } catch (error) {
                  if (this.debug) {
                    console.warn('[Volume Discount] Error parsing variant JSON from script tag:', error);
                  }
                }
              }
            }
            
            // Determine inventory tracking and backorder policy from most reliable source
            // Priority: variant-picker's current variant > fullVariant > variantPickerVariant > config data > variant from event
            // The variant-picker's .variant property has the most up-to-date variant data
            const variantPickerCurrentVariant = variantPicker?.variant;
            
            // Get inventory policy from config data as fallback (includes all variants from Liquid)
            const configInventoryPolicy = config.variantInventoryPolicies?.[variant.id]?.inventory_policy;
            const configInventoryManagement = config.variantInventoryPolicies?.[variant.id]?.inventory_management;
            
            const inventoryTracked = (variantPickerCurrentVariant?.inventory_management ?? fullVariant?.inventory_management ?? variantPickerVariant?.inventory_management ?? configInventoryManagement ?? variant.inventory_management) != null;
            let canSellOutOfStock = (variantPickerCurrentVariant?.inventory_policy ?? fullVariant?.inventory_policy ?? variantPickerVariant?.inventory_policy ?? configInventoryPolicy ?? variant.inventory_policy) === 'continue';
            
            if (this.debug) {
              console.log('[Volume Discount] Inventory policy check:', {
                fromVariantPickerCurrent: variantPickerCurrentVariant?.inventory_policy,
                fromFullVariant: fullVariant?.inventory_policy,
                fromVariantPicker: variantPickerVariant?.inventory_policy,
                fromConfig: configInventoryPolicy,
                fromVariant: variant.inventory_policy,
                canSellOutOfStock,
                inventoryTracked
              });
            }
            
            /**
             * Get inventory quantity - try multiple sources in order of reliability
             * Priority order:
             * 1. From allVariants array (most reliable - full variant data from JSON)
             * 2. Direct from variant object (may not always have inventory_quantity)
             * 3. From product-inventory component (only includes low stock variants)
             * 4. Fetch from remote order API endpoint (accounts for items already in cart)
             * 
             * If inventory cannot be determined and backorders are not allowed,
             * the block is hidden to avoid showing incorrect tier information.
             */
            const UNLIMITED_STOCK = 999999;
            let availableStock = inventoryTracked ? 0 : UNLIMITED_STOCK;
            let inventoryDetermined = !inventoryTracked; // If not tracked, we don't need to determine it
            
            if (inventoryTracked) {
              // Try 1: From allVariants array (most reliable - full variant data from JSON)
              if (fullVariant && fullVariant.inventory_quantity != null && fullVariant.inventory_quantity !== undefined) {
                availableStock = fullVariant.inventory_quantity;
                inventoryDetermined = true;
                if (this.debug) {
                  console.log('[Volume Discount] Using inventory from allVariants (most reliable):', availableStock);
                }
              }
              
              // Try 2: Direct from variant object (fallback if allVariants didn't work)
              if (!inventoryDetermined && variant.inventory_quantity != null && variant.inventory_quantity !== undefined) {
                availableStock = variant.inventory_quantity;
                inventoryDetermined = true;
                if (this.debug) {
                  console.log('[Volume Discount] Using inventory from variant object:', availableStock);
                }
              }
              
              // Try 3: Fallback to product-inventory component (only includes low stock variants)
              if (!inventoryDetermined) {
                // Try to find product-inventory in section first, then more broadly
                let productInventory = this.section?.querySelector('product-inventory');
                if (!productInventory) {
                  productInventory = container.closest('.js-product')?.querySelector('product-inventory');
                }
                if (!productInventory) {
                  productInventory = document.querySelector('product-inventory');
                }
                
                if (productInventory && typeof productInventory.getVariantInventory === 'function') {
                  try {
                    const inventoryData = productInventory.getVariantInventory();
                    if (inventoryData && Array.isArray(inventoryData)) {
                      const variantInventory = inventoryData.find(v => v && v.id === variant.id);
                      if (variantInventory && variantInventory.inventory_quantity != null) {
                  availableStock = variantInventory.inventory_quantity;
                        inventoryDetermined = true;
                        if (this.debug) {
                          console.log('[Volume Discount] Using inventory from product-inventory component (only includes low stock variants):', availableStock);
                        }
                      }
                    }
                  } catch (error) {
                    if (this.debug) {
                      console.warn('[Volume Discount] Error accessing product-inventory component:', error);
                    }
                  }
                }
              }
              
              // Try 4: Fetch from remote order API endpoint (same as Alpine component uses)
              // This gives us the most up-to-date inventory that accounts for cart quantities
              if (!inventoryDetermined) {
                try {
                  // Get product handle from URL or Alpine component
                  // Try multiple locations to find product-form (works with both variant selector types)
                  let productForm = this.section?.querySelector('product-form');
                  if (!productForm) {
                    productForm = container.closest('.js-product')?.querySelector('product-form');
                  }
                  if (!productForm) {
                    productForm = document.querySelector('product-form');
                  }
                  
                  let productHandle = null;
                  
                  // Try to get from Alpine component
                  if (productForm && window.Alpine) {
                    const alpineData = Alpine.$data(productForm);
                    if (alpineData && alpineData.productHandle) {
                      productHandle = alpineData.productHandle;
                    }
                  }
                  
                  // Fallback: extract from URL
                  if (!productHandle) {
                    const urlMatch = window.location.pathname.match(/\/products\/([^\/]+)/);
                    if (urlMatch) {
                      productHandle = urlMatch[1];
                    }
                  }
                  
                  if (productHandle && variant.id) {
                    // Fetch from the same API endpoint Alpine uses
                    const apiUrl = `/products/${productHandle}/?section_id=api-pdp-remote-order&variant=${variant.id}`;
                    
                    if (this.debug) {
                      console.log('[Volume Discount] Fetching inventory from API:', apiUrl);
                    }
                    
                    const response = await fetch(apiUrl);
                    const responseText = await response.text();
                    const html = new DOMParser().parseFromString(responseText, 'text/html');
                    const jsonScript = html.querySelector('script[type="application/json"]');
                    
                    if (jsonScript) {
                      const json = JSON.parse(jsonScript.textContent);
                      if (json.variantInventory != null) {
                        availableStock = json.variantInventory;
                        inventoryDetermined = true;
                        if (this.debug) {
                          console.log('[Volume Discount] Using inventory from API endpoint (accounts for cart):', availableStock);
                        }
                      }
                    }
                  }
                } catch (error) {
                  if (this.debug) {
                    console.warn('[Volume Discount] Error fetching inventory from API:', error);
                  }
                }
              }
              
              // If we still couldn't determine inventory, hide the block to avoid showing incorrect information
              // UNLESS backorders are allowed - in that case, show all tiers
              if (!inventoryDetermined) {
                if (canSellOutOfStock) {
                  // Backorders allowed - set availableStock to a high value so all tiers show
                  availableStock = UNLIMITED_STOCK;
                  inventoryDetermined = true; // Mark as determined so we continue
                  if (this.debug) {
                    console.log('[Volume Discount] Cannot determine inventory, but backorders allowed - showing all tiers');
                  }
                } else {
                  // Inventory is tracked but we can't determine the quantity
                  // Hide the block to avoid confusing customers with incorrect tier information
                  if (window.Alpine && container) {
                    const alpineData = Alpine.$data(container);
                    if (alpineData) {
                      alpineData.hasDiscounts = false;
                    }
                  }
                  if (this.debug) {
                    console.warn('[Volume Discount] Cannot determine inventory quantity, hiding block to avoid showing incorrect information');
                  }
                  return;
                }
              }
            }
            
            /**
             * If backorders are allowed, treat as unlimited stock for tier visibility
             * This ensures all tiers show even when inventory is 0 or negative (oversold).
             * Also remove max attribute from quantity input to allow customers to order any quantity.
             */
            if (canSellOutOfStock) {
              const originalStock = availableStock;
              availableStock = UNLIMITED_STOCK;
              if (this.debug) {
                console.log('[Volume Discount] Backorders allowed - treating as unlimited stock for tier visibility', {
                  originalInventory: originalStock,
                  setTo: availableStock,
                  inventoryTracked
                });
              }
              
              // Remove max attribute from quantity input to allow any quantity
              const quantityInput = this.findQuantityInput();
              if (quantityInput) {
                quantityInput.removeAttribute('max');
                if (this.debug) {
                  console.log('[Volume Discount] Removed max attribute from quantity input (backorders allowed)');
                }
              }
            } else if (inventoryTracked && !canSellOutOfStock) {
              // If inventory is tracked and backorders not allowed, set max to available stock
              const quantityInput = this.findQuantityInput();
              if (quantityInput && availableStock > 0) {
                quantityInput.setAttribute('max', availableStock);
                if (this.debug) {
                  console.log('[Volume Discount] Set max attribute on quantity input to', availableStock);
                }
              } else if (quantityInput && availableStock <= 0) {
                quantityInput.removeAttribute('max');
              }
            }
            
            if (this.debug) {
              console.log('[Volume Discount] Inventory info:', {
                inventoryTracked,
                canSellOutOfStock,
                availableStock
              });
            }
            
            // Calculate which tiers should be visible
            let visibleTierCount = 0;
            let visibleTiersWithDiscount = 0; // Track tiers that have discounts > 0%
            const allTiers = this.querySelectorAll('.volume-pricing-tier');
            
            if (allTiers.length === 0) {
              if (this.debug) {
                console.warn('[Volume Discount] No tier elements found');
              }
              return;
            }
            
            // Remember the currently selected tier quantity before updating
            const currentlySelectedTier = this.querySelector('.volume-pricing-tier.is-selected:not(.is-disabled)');
            const rememberedQuantity = currentlySelectedTier ? parseInt(currentlySelectedTier.dataset.quantity, 10) : null;
            
            if (this.debug) {
              console.log('[Volume Discount] Processing', allTiers.length, 'tiers for variant', variant.id);
            }
            
            if (this.debug && rememberedQuantity) {
              console.log('[Volume Discount] Remembering selected tier quantity:', rememberedQuantity);
            }
            
            // Get pre-formatted prices from JSON script tag
            const priceDataScript = container.querySelector('[data-volume-discount-prices]');
            if (!priceDataScript) {
              if (this.debug) {
                console.warn('[Volume Discount] Price data script tag not found');
              }
              return;
            }
            
            let formattedPrices;
            try {
              formattedPrices = JSON.parse(priceDataScript.textContent);
            } catch (error) {
              if (this.debug) {
                console.error('[Volume Discount] Error parsing price data:', error);
              }
              return;
            }
            
            // Get formatted prices for this variant
            const variantPriceData = formattedPrices.formatted[variant.id];
            if (!variantPriceData) {
              if (this.debug) {
                console.warn('[Volume Discount] No price data found for variant:', variant.id);
              }
              // No price data means this variant doesn't have discounts
              // Only update Alpine if this is a change from a variant with discounts
              if (this.previousVariantHasDiscounts === true) {
                if (window.Alpine && container) {
                  const alpineData = Alpine.$data(container);
                  if (alpineData) {
                    alpineData.hasDiscounts = false;
                  }
                }
              }
              this.previousVariantHasDiscounts = false;
              return;
            }
            
            // Check if any tier has negative price - if so, hide entire block
            // Skip this check if debug mode is enabled
            const debugMode = this.dataset.debug === 'true';
            
            // Always log configTiersStructure to understand Discount Kit data format
            if (config.configTiersStructure) {
            }
            let hasNegativePriceTier = false;
            
            if (variantPriceData && variantPriceData.tiers) {
              for (const tierQty in variantPriceData.tiers) {
                const tierPriceData = variantPriceData.tiers[tierQty];
                if (tierPriceData) {
                  // Check both hasNegativePrice flag and actual price values
                  const tierHasNegativeFlag = tierPriceData.hasNegativePrice === true;
                  
                  // Also check if price strings contain negative values (fallback check)
                  const tierPriceStr = tierPriceData.tierPrice || '';
                  const tierTotalStr = tierPriceData.tierTotal || '';
                  const tierPriceIsNegative = tierPriceStr.includes('-') || tierTotalStr.includes('-');
                  
                  // Also check raw numeric values if available (most reliable)
                  const tierPriceRaw = tierPriceData.tierPriceRaw;
                  const tierTotalRaw = tierPriceData.tierTotalRaw;
                  const tierPriceRawIsNegative = (tierPriceRaw !== undefined && tierPriceRaw < 0) || 
                                                  (tierTotalRaw !== undefined && tierTotalRaw < 0);
                  
                  if (tierHasNegativeFlag || tierPriceIsNegative || tierPriceRawIsNegative) {
                    hasNegativePriceTier = true;
                    if (this.debug) {
                      console.warn('[Volume Discount] Tier', tierQty, 'has negative price:', {
                        hasNegativeFlag: tierHasNegativeFlag,
                        tierPrice: tierPriceStr,
                        tierTotal: tierTotalStr,
                        priceIsNegative: tierPriceIsNegative,
                        tierPriceRaw: tierPriceRaw,
                        tierTotalRaw: tierTotalRaw,
                        tierPriceRawIsNegative: tierPriceRawIsNegative,
                        willHideBlock: !debugMode
                      });
                    }
                    break;
                  }
                }
              }
            }
            
            // If any tier has negative price, hide entire block (unless debug mode is enabled)
            if (hasNegativePriceTier && !debugMode) {
              if (window.Alpine && container) {
                const alpineData = Alpine.$data(container);
                if (alpineData) {
                  alpineData.hasDiscounts = false;
                }
              }
              this.previousVariantHasDiscounts = false;
              if (this.debug) {
                console.warn('[Volume Discount] Hiding entire block due to negative price tier');
              }
              return;
            }
            
            if (this.debug && hasNegativePriceTier) {
              console.log('[Volume Discount] Debug mode enabled - showing block despite negative price tier');
            }
            
            /**
             * Check if this variant is eligible for discounts based on DiscountKit's matchRule.selection
             * 
             * DiscountKit stores variant-specific eligibility in config.matchRule.selection:
             * - If productSelection.variants is null/undefined/empty: all variants of that product are eligible
             * - If productSelection.variants is an array: only variants in that array are eligible
             * 
             * We need to verify:
             * 1. The variant belongs to a product in the selection
             * 2. If the product has specific variant restrictions, the variant must be in the list
             */
            let variantEligible = false;
            const discountKitData = config.discountKitData;
            
            if (discountKitData && discountKitData.volumeDiscountKeys && discountKitData.volumeDiscountKeys.config) {
              const matchRule = discountKitData.volumeDiscountKeys.config.matchRule;
              // Collection-based discount: Liquid already verified product is in the collection
              if (matchRule && matchRule.type === 'collection' && matchRule.include && Array.isArray(matchRule.include) && matchRule.include.length > 0) {
                variantEligible = true;
              } else if (!matchRule || !matchRule.selection || !Array.isArray(matchRule.selection) || matchRule.selection.length === 0) {
                // No matchRule or selection is empty: discount applies to all products/variants
                variantEligible = true;
              } else if (matchRule && matchRule.selection && Array.isArray(matchRule.selection)) {
                const variantIdStr = variant.id.toString();
                
                /**
                 * Try to get product ID from multiple sources (in order of reliability)
                 * This is needed to match variants against DiscountKit's product-level selections
                 * 
                 * Priority order:
                 * 1. From variant object directly
                 * 2. From fullVariant (from allVariants array in event)
                 * 3. From variant-picker's variant data
                 * 4. From variant-picker's data object (product-level data)
                 * 5. From variant in variant-picker's data array
                 * 6. From product JSON script tag (common in Shopify themes)
                 * 7. From variant-picker's data.product (if available)
                 */
                let variantProductId = variant.product_id || variant.productId || variant.product?.id;
                
                if (!variantProductId && fullVariant) {
                  variantProductId = fullVariant.product_id || fullVariant.productId || fullVariant.product?.id;
                }
                
                if (!variantProductId && variantPickerVariant) {
                  variantProductId = variantPickerVariant.product_id || variantPickerVariant.productId || variantPickerVariant.product?.id;
                }
                
                if (!variantProductId && variantPicker && variantPicker.data) {
                  variantProductId = variantPicker.data.product?.id || variantPicker.data.product_id;
                }
                
                if (!variantProductId && variantPicker && variantPicker.data && variantPicker.data.variants) {
                  const variantInData = variantPicker.data.variants.find(v => v && v.id === variant.id);
                  if (variantInData) {
                    variantProductId = variantInData.product_id || variantInData.productId || variantInData.product?.id;
                  }
                }
                
                if (!variantProductId) {
                  const productJsonScript = document.querySelector('#ProductJson-product-template, script[type="application/json"][data-product-json], script[type="application/json"]#ProductJson');
                  if (productJsonScript) {
                    try {
                      const productData = JSON.parse(productJsonScript.textContent);
                      variantProductId = productData.id || productData.product_id;
                    } catch (error) {
                      if (this.debug) {
                        console.warn('[Volume Discount] Error parsing product JSON:', error);
                      }
                    }
                  }
                }
                
                if (!variantProductId && variantPicker && variantPicker.data) {
                  if (variantPicker.data.product && variantPicker.data.product.id) {
                    variantProductId = variantPicker.data.product.id;
                  } else if (variantPicker.data.product_id) {
                    variantProductId = variantPicker.data.product_id;
                  }
                }
                
                if (this.debug) {
                  console.log('[Volume Discount] Product ID lookup:', {
                    variantId: variant.id,
                    variantProductId,
                    sources: {
                      fromVariant: variant.product_id || variant.productId || variant.product?.id,
                      fromFullVariant: fullVariant ? (fullVariant.product_id || fullVariant.productId || fullVariant.product?.id) : null,
                      fromVariantPickerVariant: variantPickerVariant ? (variantPickerVariant.product_id || variantPickerVariant.productId || variantPickerVariant.product?.id) : null,
                      fromVariantPickerData: variantPicker?.data?.product?.id || variantPicker?.data?.product_id
                    }
                  });
                }
                
                // Check all products in the selection
                for (const productSelection of matchRule.selection) {
                  /**
                   * If variants is null/undefined/empty, all variants of this product are eligible
                   * But we must verify this variant belongs to this product to avoid false positives
                   */
                  if (productSelection.variants === null || productSelection.variants === undefined || (Array.isArray(productSelection.variants) && productSelection.variants.length === 0)) {
                    if (variantProductId) {
                      const productIdStr = variantProductId.toString();
                      const selectionProductIdStr = productSelection.id.toString();
                      if (productIdStr === selectionProductIdStr) {
                        variantEligible = true;
                        break;
                      }
                    } else {
                      /**
                       * Fallback: If we can't get product ID from variant, try to get current product ID
                       * and verify it matches this product selection before marking as eligible.
                       * This prevents marking variants from different products as eligible.
                       */
                      let currentProductId = config.currentProductId;
                      
                      // Try additional sources if config doesn't have it
                      if (!currentProductId && variantPicker && variantPicker.data) {
                        if (variantPicker.data.product && variantPicker.data.product.id) {
                          currentProductId = variantPicker.data.product.id;
                        } else if (variantPicker.data.product_id) {
                          currentProductId = variantPicker.data.product_id;
                        }
                      }
                      
                      // Try product JSON script tag
                      if (!currentProductId) {
                        const productJsonScript = document.querySelector('#ProductJson-product-template, script[type="application/json"][data-product-json], script[type="application/json"]#ProductJson');
                        if (productJsonScript) {
                          try {
                            const productData = JSON.parse(productJsonScript.textContent);
                            currentProductId = productData.id || productData.product_id;
                          } catch (error) {
                            // Ignore error
                          }
                        }
                      }
                      
                      if (currentProductId) {
                        const currentProductIdStr = currentProductId.toString();
                        const selectionProductIdStr = productSelection.id.toString();
                        
                        // Only mark as eligible if current product matches this selection
                        if (currentProductIdStr === selectionProductIdStr) {
                          // Current product matches this product selection with all variants eligible
                          // Verify variant exists in variant-picker (belongs to current product)
                          if (variantPicker && variantPicker.data && variantPicker.data.variants) {
                            const variantExistsInPicker = variantPicker.data.variants.some(v => v && v.id === variant.id);
                            if (variantExistsInPicker) {
                              variantEligible = true;
                              if (this.debug) {
                                console.log('[Volume Discount] Variant eligible via fallback (current product matches selection with all variants eligible):', {
                                  variantId: variant.id,
                                  currentProductId: currentProductIdStr,
                                  productSelectionId: selectionProductIdStr,
                                  variantExistsInPicker: true
                                });
                              }
                              break;
                            }
                          }
                        } else if (this.debug) {
                          console.log('[Volume Discount] Current product does not match selection (skipping fallback):', {
                            variantId: variant.id,
                            currentProductId: currentProductIdStr,
                            productSelectionId: selectionProductIdStr
                          });
                        }
                      } else if (this.debug) {
                        console.log('[Volume Discount] Cannot determine current product ID (skipping fallback):', {
                          variantId: variant.id,
                          productSelectionId: productSelection.id
                        });
                      }
                    }
                  } else if (Array.isArray(productSelection.variants)) {
                    // Check if this variant ID is in the eligible variants list
                    const isEligible = productSelection.variants.some(v => {
                      const eligibleVariantId = v.id ? v.id.toString() : v.toString();
                      return eligibleVariantId === variantIdStr;
                    });
                    if (isEligible) {
                      variantEligible = true;
                      break;
                    }
                  }
                }
              }
            } else {
              // If DiscountKit data is not available, we cannot determine eligibility
              // DO NOT assume variant is eligible - this causes blocks to show on all products
              // Only mark as eligible if we have explicit confirmation from Liquid that product matches
              // Check if config has currentProductId and it matches (Liquid already filtered)
              if (config.currentProductId) {
                const currentProductIdStr = config.currentProductId.toString();
                // If Liquid rendered the block, it means product is eligible (Liquid already checked)
                // But we should still verify variant has discounts
                variantEligible = true;
              } else {
                // No DiscountKit data AND no product ID in config - cannot determine eligibility
                // Default to false to prevent showing on all products
                variantEligible = false;
              }
            }
            
            // Also check if any tiers have discounts > 0% from DiscountKit metafield data
            const variantHasConfigDiscounts = config.tiers.some(tier => tier.discount > 0);
            
            // Variant has discounts only if BOTH conditions are true:
            // 1. Variant is eligible according to DiscountKit's matchRule.selection
            // 2. Config shows discounts (from DiscountKit metafield)
            const variantHasDiscounts = variantEligible && variantHasConfigDiscounts;
            
            if (this.debug) {
              const variantIdStr = variant.id.toString();
              const variantProductId = variant.product_id || variant.productId || variant.product?.id;
              const eligibleVariantIds = [];
              const productsWithAllVariants = [];
              
              if (discountKitData?.volumeDiscountKeys?.config?.matchRule?.selection) {
                for (const productSelection of discountKitData.volumeDiscountKeys.config.matchRule.selection) {
                  if (productSelection.variants === null || productSelection.variants === undefined || (Array.isArray(productSelection.variants) && productSelection.variants.length === 0)) {
                    productsWithAllVariants.push(productSelection.id);
                  } else if (Array.isArray(productSelection.variants)) {
                    productSelection.variants.forEach(v => {
                      const id = v.id ? v.id.toString() : v.toString();
                      eligibleVariantIds.push(id);
                    });
                  }
                }
              }
              
              console.log('[Volume Discount] Checking variant discount eligibility:', {
                variantId: variant.id,
                variantIdStr,
                variantProductId,
                variantEligible,
                variantHasConfigDiscounts,
                variantHasDiscounts,
                eligibleVariantIds: eligibleVariantIds.slice(0, 10), // Show first 10 for brevity
                totalEligibleVariants: eligibleVariantIds.length,
                isInEligibleList: eligibleVariantIds.includes(variantIdStr),
                productsWithAllVariants,
                variantBelongsToProductWithAllVariants: variantProductId && productsWithAllVariants.includes(variantProductId.toString())
              });
            }
            
            // Determine if we need to show/hide the container
            // Only update Alpine when switching between variants with/without discounts
            const currentVariantHasDiscounts = variantHasDiscounts;
            const shouldUpdateAlpine = this.previousVariantHasDiscounts !== currentVariantHasDiscounts;
            
            if (!variantHasDiscounts) {
              if (this.debug) {
                console.log('[Volume Discount] Variant has no discounts or is not eligible, hiding block', {
                  variantEligible,
                  variantHasConfigDiscounts,
                  shouldUpdateAlpine,
                  previousState: this.previousVariantHasDiscounts
                });
              }
              // Only update Alpine if this is a change from a variant with discounts
              if (shouldUpdateAlpine) {
                if (window.Alpine && container) {
                  const alpineData = Alpine.$data(container);
                  if (alpineData) {
                    alpineData.hasDiscounts = false;
                  }
                }
              }
              this.previousVariantHasDiscounts = false;
              return;
            }
            
            // Variant has discounts - update Alpine only if needed
            if (shouldUpdateAlpine) {
              if (window.Alpine && container) {
                const alpineData = Alpine.$data(container);
                if (alpineData) {
                  alpineData.hasDiscounts = true;
                  if (this.debug) {
                    console.log('[Volume Discount] Updated Alpine hasDiscounts to true (switching from variant without discounts)');
                  }
                }
              }
            }
            this.previousVariantHasDiscounts = true;
            
            // Pre-calculate debug data if needed
            const debugAllConfigTiers = this.debug ? config.tiers.map(t => ({ quantity: t.quantity, discount: t.discount })) : null;
            
            /**
             * Main tier visibility and pricing update loop
             * 
             * After determining inventory availability (availableStock) and getting price data (variantPriceData),
             * this loop processes each tier element to:
             * 1. Enable/disable tiers based on inventory (disable tiers where quantity > availableStock)
             * 2. Update prices for all tiers using pre-formatted data from Liquid
             * 3. Update aria-labels for accessibility
             * 4. Track tiers with discounts > 0% to determine if block should be shown
             * 
             * Tiers that exceed available inventory are disabled (is-disabled class).
             * All tiers get their prices updated from the variantPriceData object.
             */
            
            /**
             * Reset all tier disabled states to ensure clean state before processing
             * This prevents previous variant's disabled states from persisting when switching variants.
             */
            for (const tierEl of allTiers) {
              tierEl.classList.remove('is-disabled');
            }
            
            // Process each tier to determine availability and update prices
            for (const tierEl of allTiers) {
              const tierQty = parseInt(tierEl.dataset.quantity, 10);
              
              // Check if tier should be available
              // If backorders are allowed, all tiers are available regardless of inventory
              // Otherwise, tiers are available if quantity <= availableStock
              const isTierAvailable = canSellOutOfStock || !inventoryTracked || tierQty <= availableStock;
              
              if (this.debug) {
                console.log('[Volume Discount] Tier availability check:', {
                  tierQty,
                  availableStock,
                  inventoryTracked,
                  canSellOutOfStock,
                  isTierAvailable,
                  condition: canSellOutOfStock ? 'backorders allowed' : (!inventoryTracked ? 'not tracked' : `tierQty (${tierQty}) <= availableStock (${availableStock})`)
                });
              }
              
              // Find tier config for this quantity
              const tierConfig = config.tiers.find(t => t.quantity === tierQty);
              
              // Get price data for this tier (if available)
              const tierPriceData = variantPriceData ? variantPriceData.tiers[tierQty] : null;
              
              if (!tierPriceData) {
                // No price data means this tier doesn't exist or variant doesn't have discounts
                tierEl.classList.add('is-disabled');
                tierEl.style.display = 'none';
                continue;
              }
              
              // Get tier discount from price data (more reliable than config)
              // tierPriceData.discount is the volume discount value (10, 20, 30 for percentage, or cents for fixed amount)
              // Use tierConfig discount if available, otherwise use price data discount
              const tierDiscount = tierConfig ? tierConfig.discount : (tierPriceData.discount || 0);
              
              if (this.debug) {
                const tierDetail = config.tierDetails?.find(t => t.buys === tierQty);
                const allTierDetails = config.tierDetails || [];
                
                console.log('[Volume Discount] Tier config matching:', {
                  tierQuantity: tierQty,
                  configFound: !!tierConfig,
                  configDetails: tierConfig ? {
                    quantity: tierConfig.quantity,
                    discount: tierConfig.discount
                  } : null,
                  tierDiscount,
                  tierDetailFromConfig: tierDetail,
                  allAvailableTiers: allTierDetails.map(t => ({
                    buys: t.buys,
                    gets: t.gets,
                    getsType: t.getsType,
                    rewardType: t.rewardType
                  })),
                  rewardType: config.discountKitData?.rewardType,
                  calculation: tierConfig && tierDetail ? {
                    buys: tierDetail.buys,
                    getsValue: tierDetail.gets,
                    getsValueFormatted: `€${(tierDetail.gets / 100).toFixed(2)}`,
                    getsType: tierDetail.getsType,
                    rewardType: tierDetail.rewardType,
                    variantPrice: variant.price,
                    variantPriceFormatted: `€${(variant.price / 100).toFixed(2)}`,
                    variantCompareAtPrice: variant.compare_at_price || variant.compareAtPrice || null,
                    usingOriginalPrice: 'No (using variant.price - matches Shopify combined discount behavior)',
                    note: 'When combined discounts are enabled, Shopify applies volume discount to variant.price (which may already be discounted), not to compare_at_price',
                    expectedPerItem: tierDetail.rewardType === 'FIXED_AMOUNT' 
                      ? `variant.price (${variant.price}) - gets.value (${tierDetail.gets}) = ${variant.price - tierDetail.gets} cents (€${((variant.price - tierDetail.gets) / 100).toFixed(2)})`
                      : `variant.price (${variant.price}) * (100 - ${tierDetail.gets}) / 100 = ${variant.price * (100 - tierDetail.gets) / 100} cents`,
                    expectedTotal: tierConfig ? `perItem * ${tierQty} = ${(variant.price - (tierDetail.rewardType === 'FIXED_AMOUNT' ? tierDetail.gets : 0)) * tierQty} cents` : 'N/A',
                    fixedAmountInterpretation: tierDetail.rewardType === 'FIXED_AMOUNT' ? {
                      currentInterpretation: `€${(tierDetail.gets / 100).toFixed(2)} per item (as stored in metafield)`,
                      ifTotalDiscount: tierQty > 0 ? `€${(tierDetail.gets / tierQty / 100).toFixed(2)} per item (if ${tierDetail.gets} is total discount)` : 'N/A',
                      warning: tierDetail.gets > variant.price ? `⚠️ Discount value (${tierDetail.gets}) exceeds variant price (${variant.price}) - this would result in negative price!` : null
                    } : null
                  } : null
                });
              }
              
              // Determine if tier should be shown (based on discount)
              // Only show tier if:
              // 1. It's tier 1 (baseline, always show)
              // 2. OR it has a discount > 0 (skip intermediate tiers without discounts)
              // Use tierDiscount (from config or price data) instead of just tierConfig.discount
              // Note: Negative price check is done before processing tiers - if any tier has negative price, entire block is hidden
              const shouldShowTier = tierQty === 1 || tierDiscount > 0;
              
              // Check if tier should be disabled due to insufficient inventory
              // Tiers with discounts should be shown but disabled (grayed out) when inventory is insufficient
              const shouldDisableTier = shouldShowTier && !isTierAvailable;
              
              // Update tier visibility and disabled state
              if (shouldShowTier) {
                tierEl.style.display = '';
                visibleTierCount++;
                
                // Set disabled state based on inventory
                if (shouldDisableTier) {
                  tierEl.classList.add('is-disabled');
                  tierEl.setAttribute('aria-disabled', 'true');
                } else {
                  tierEl.classList.remove('is-disabled');
                  tierEl.removeAttribute('aria-disabled');
                }
                
                // Track if this tier has a discount > 0%
                // Use tierDiscount (from config or price data) instead of just tierConfig.discount
                if (tierDiscount > 0) {
                  visibleTiersWithDiscount++;
              if (this.debug) {
                const tierDetail = config.tierDetails?.find(t => t.buys === tierQty);
                console.log('[Volume Discount] Tier has discount:', {
                  tierQty,
                  discount: tierConfig.discount,
                  tierDetail: tierDetail,
                  rewardType: config.discountKitData?.rewardType,
                  interpretation: tierDetail ? {
                    getsValue: tierDetail.gets,
                    isFixedAmount: tierDetail.rewardType === 'FIXED_AMOUNT',
                    isPercentage: tierDetail.rewardType === 'PERCENTAGE',
                    valueInCents: tierDetail.gets,
                    valueInEuros: (tierDetail.gets / 100).toFixed(2),
                    note: tierDetail.rewardType === 'FIXED_AMOUNT' 
                      ? 'This is the discount amount in cents per item'
                      : 'This is the percentage discount (0-100)'
                  } : null
                });
              }
                }
              } else {
                tierEl.classList.add('is-disabled');
                tierEl.style.display = 'none';
                if (this.debug) {
                  if (!isTierAvailable) {
                    console.log('[Volume Discount] Tier hidden due to insufficient inventory:', tierQty);
                  } else if (tierQty > 1 && tierDiscount === 0) {
                    console.log('[Volume Discount] Tier hidden - no discount (skipping intermediate tier):', tierQty);
                  }
                }
              }
              
              // Update prices for this tier (even if disabled, update for when it becomes enabled)
              // tierPriceData was already retrieved above, so we can use it here
              if (tierPriceData) {
                
              if (this.debug) {
                const tierDetail = config.tierDetails?.find(t => t.buys === tierQty);
                const calculationBreakdown = tierDetail && variant ? {
                  variantPrice: variant.price,
                  variantPriceFormatted: (variant.price / 100).toFixed(2) + ' EUR',
                  getsValue: tierDetail.gets,
                  getsValueFormatted: (tierDetail.gets / 100).toFixed(2) + ' EUR',
                  rewardType: tierDetail.rewardType,
                  currentCalculation: tierDetail.rewardType === 'FIXED_AMOUNT'
                    ? `Per item: ${variant.price} - ${tierDetail.gets} = ${variant.price - tierDetail.gets} cents (${((variant.price - tierDetail.gets) / 100).toFixed(2)} EUR)`
                    : `Per item: ${variant.price} * (100 - ${tierDetail.gets}) / 100 = ${Math.round(variant.price * (100 - tierDetail.gets) / 100)} cents`,
                  currentTotal: tierDetail.rewardType === 'FIXED_AMOUNT'
                    ? `Total for ${tierQty}: ${(variant.price - tierDetail.gets) * tierQty} cents (${(((variant.price - tierDetail.gets) * tierQty) / 100).toFixed(2)} EUR)`
                    : `Total for ${tierQty}: ${Math.round(variant.price * (100 - tierDetail.gets) / 100) * tierQty} cents`,
                  alternativeCalculations: tierDetail.rewardType === 'FIXED_AMOUNT' ? {
                    ifDividedByQuantity: `If discount is TOTAL (divide by qty): ${variant.price} - (${tierDetail.gets} / ${tierQty}) = ${variant.price - Math.round(tierDetail.gets / tierQty)} cents (${((variant.price - Math.round(tierDetail.gets / tierQty)) / 100).toFixed(2)} EUR per item) = ${((variant.price - Math.round(tierDetail.gets / tierQty)) * tierQty / 100).toFixed(2)} EUR total`,
                    ifPerItem850: `If discount should be 850 (€8.50 per item): ${variant.price} - 850 = ${variant.price - 850} cents (${((variant.price - 850) / 100).toFixed(2)} EUR per item) = ${((variant.price - 850) * tierQty / 100).toFixed(2)} EUR total`,
                    adminShows: 'Admin shows: Fixed amount off €8.50 for quantity 2',
                    expectedByUser: 'User expects: €8.50 per item = €17 total savings = €118.00 total for 2 items',
                    discrepancy: `Metafield has ${tierDetail.gets} (€${(tierDetail.gets / 100).toFixed(2)}) but admin shows €8.50. Possible issues: 1) Value stored incorrectly, 2) Value is total not per-item, 3) Currency conversion issue, 4) Discount needs to be divided by quantity (${tierDetail.gets} / ${tierQty} = ${Math.round(tierDetail.gets / tierQty)} = €${(Math.round(tierDetail.gets / tierQty) / 100).toFixed(2)})`
                  } : null
                } : null;
                
                console.log('💰 [Volume Discount] Price Calculation:', {
                  tierQuantity: tierQty,
                  tierPrice: tierPriceData.tierPrice,
                  tierTotal: tierPriceData.tierTotal,
                  originalTotal: tierPriceData.originalTotal,
                  discount: tierPriceData.discount,
                  rewardType: tierPriceData.rewardType,
                  getsType: tierPriceData.getsType,
                  isPercentageDiscount: tierPriceData.isPercentageDiscount,
                  convertedPercentage: tierPriceData.convertedPercentage,
                  variantPrice: variant.price,
                  variantCompareAtPrice: tierPriceData.variantCompareAtPrice,
                  tierDetail: tierDetail,
                  calculationBreakdown: calculationBreakdown,
                  calculationNote: tierPriceData.getsType === 'fixedAmount' 
                    ? `⚠️ Fixed amount discount detected: ${variant.price} - ${tierPriceData.discount} = ${variant.price - tierPriceData.discount} cents. If this results in negative price, the discount may be configured incorrectly in Discount Kit (should be percentage, not fixed amount).`
                    : `Percentage discount: ${variant.price} * (100 - ${tierPriceData.discount}) / 100 = ${Math.round(variant.price * (100 - tierPriceData.discount) / 100)} cents`
                });
              }
                
                // Update tier total price
                const totalPriceEl = tierEl.querySelector('.tier-total-price');
                if (totalPriceEl) {
                  totalPriceEl.textContent = tierPriceData.tierTotal;
                }
                
                // Update tier price per unit
                const pricePerUnitEl = tierEl.querySelector('.tier-price-per-unit');
                if (pricePerUnitEl) {
                  const perUnitLabel = pricePerUnitEl.dataset.perUnitLabel || '';
                  pricePerUnitEl.textContent = tierPriceData.tierPrice + (perUnitLabel ? ' ' + perUnitLabel : '');
                }
                
                // Update original price visibility
                const originalPriceEl = tierEl.querySelector('.tier-original-price');
                if (originalPriceEl) {
                  // Use tierDiscount (from config or price data) instead of just tierConfig.discount
                  if (tierDiscount > 0) {
                    originalPriceEl.textContent = tierPriceData.originalTotal;
                    originalPriceEl.style.display = '';
                  } else {
                    originalPriceEl.style.display = 'none';
                  }
                }
                
                // Update discount badge visibility
                const discountBadgeEl = tierEl.querySelector('.tier-discount-badge');
                if (discountBadgeEl) {
                  // Show badge if tier has discount > 0
                  // Use tierDiscount (from config or price data) instead of just tierConfig.discount
                  // Note: Negative price check is done before processing tiers - if any tier has negative price, entire block is hidden
                  if (tierDiscount > 0) {
                    // Determine discount type based on what Discount Kit provides
                    const tierDetail = config.tierDetails?.find(t => t.buys === parseInt(tierQty));
                    const getsType = tierPriceData.getsType || tierDetail?.getsType || 'percentage';
                    const rewardType = config.discountKitData?.rewardType || tierPriceData.rewardType || 'PERCENTAGE';
                    const discountValue = tierDiscount;
                    
                    // Strategy (PRIORITY ORDER):
                    // 1. Top-level rewardType is authoritative - if PERCENTAGE, treat as percentage
                    // 2. If getsType is 'percentage', treat as percentage
                    // 3. If value is 0-100, treat as percentage
                    // Otherwise, treat as fixed amount
                    let isFixedAmount = true;
                    
                    if (rewardType === 'PERCENTAGE') {
                      // Top-level rewardType is authoritative - treat as percentage regardless of getsType
                      isFixedAmount = false;
                    } else if (getsType === 'percentage') {
                      isFixedAmount = false;
                    } else if (discountValue <= 100) {
                      isFixedAmount = false;
                    }
                    
                    const displayDiscount = tierDiscount;
                    
                    if (isFixedAmount) {
                      // For fixed amount discounts: Calculate percentage: (discount_amount / variant_price) * 100
                      // Currency handling:
                      // - If discount has currencyCode: Both values are in same currency (filtered by selection logic)
                      // - If discount has no currencyCode: Discount Kit defaults to shop's base currency (DKK)
                      //   Discount Kit ensures currency consistency, so calculation is correct
                      // Use tierDiscount which comes from price data (more reliable)
                      const discountInCents = tierDiscount;
                      if (variant && variant.price > 0) {
                        const discountPercentage = ((discountInCents / variant.price) * 100).toFixed(1);
                        discountBadgeEl.textContent = `-${discountPercentage}%`;
                      } else {
                        // Fallback: If variant price not available, keep badge from Liquid template
                        // Liquid template calculates percentage using current_variant.price on initial render
                      }
                    } else {
                      // Percentage discounts: Show the volume discount percentage (10%, 20%, 30%)
                      // This is the discount from the volume discount itself, not the combined discount
                      // Use convertedPercentage if available, otherwise use tierDiscount
                      discountBadgeEl.textContent = `-${displayDiscount}%`;
                    }
                    discountBadgeEl.style.display = '';
                  } else {
                    discountBadgeEl.style.display = 'none';
                  }
                }
                
                // Update aria-label
                const unitsText = tierEl.querySelector('.tier-quantity')?.textContent.trim() || `${tierQty} stk.`;
                tierEl.setAttribute('aria-label', `${unitsText} - ${tierPriceData.tierTotal} total`);
              }
            }
            
            // Show/hide container and header based on visible tiers with discounts
            // Alpine.js state is already updated above when checking variant eligibility
            // Alpine.js handles the main visibility, but we still need to handle heading visibility
            const heading = container.querySelector('.volume-pricing-heading');
            if (visibleTierCount === 0 || visibleTiersWithDiscount === 0) {
              if (heading) heading.style.display = 'none';
              this.debugLog('No visible tiers with discounts, hiding heading', {
                visibleTierCount,
                visibleTiersWithDiscount
              });
            } else {
              if (heading) {
                heading.style.display = '';
                heading.style.visibility = 'visible';
              }
              
              if (this.debug) {
                console.log('[Volume Discount] Visible tiers:', visibleTierCount, 'out of', allTiers.length);
              }
              
              // Try to select the remembered tier quantity if it's available, otherwise select first visible tier
              let tierToSelect = null;
              
              if (rememberedQuantity !== null) {
                tierToSelect = Array.from(allTiers).find(tier => {
                  const tierQty = parseInt(tier.dataset.quantity, 10);
                  return tierQty === rememberedQuantity && !tier.classList.contains('is-disabled');
                });
                
                if (tierToSelect) {
                  this.debugLog('Found remembered tier quantity:', rememberedQuantity);
                }
              }
              
              // If remembered tier not found or not available, select first available tier (not disabled)
              if (!tierToSelect) {
                tierToSelect = Array.from(allTiers).find(tier => !tier.classList.contains('is-disabled'));
                if (rememberedQuantity !== null) {
                  this.debugLog('Remembered tier quantity not available, selecting first available tier');
                }
              }
              
              // Only auto-select if user hasn't manually selected a tier
              if (tierToSelect && !this.userSelectedTier) {
                this.selectTier(tierToSelect);
              }
            }
            
            // Reset user selection flag after processing variant change
            // This ensures the flag is cleared even if Promise.resolve() hasn't fired yet
            if (this.userSelectedTier) {
              this.userSelectedTier = false;
            }
          }
        
          /**
           * Handles tier click events
           * 
           * Uses a flag to prevent handleVariantChange from auto-selecting a different tier
           * immediately after the user manually selects one. This prevents a race condition
           * where variant change events might fire right after a tier click.
           * 
           * @param {MouseEvent} event - Click event
           */
          handleTierClick(event) {
            this.userSelectedTier = true;
            const selectedTier = event.currentTarget;
            this.selectTier(selectedTier);
            
            // Reset flag after current event loop completes (faster than arbitrary timeout)
            // This allows handleVariantChange to see the flag if it fires synchronously
            Promise.resolve().then(() => {
              this.userSelectedTier = false;
            });
          }
        
          /**
           * Handles keyboard navigation for tiers
           * @param {KeyboardEvent} event - Keydown event
           */
          handleTierKeydown(event) {
            const currentTier = event.currentTarget;
            const allTiers = Array.from(this.querySelectorAll('.volume-pricing-tier'));
            const visibleTiers = allTiers.filter(tier => !tier.classList.contains('is-disabled'));
            const currentIndex = visibleTiers.indexOf(currentTier);
            
            let targetTier = null;
            
            // Handle Enter and Space for selection
            if (event.key === 'Enter' || event.key === ' ') {
              event.preventDefault();
              this.selectTier(currentTier);
              return;
            }
            
            // Handle arrow key navigation
            if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
              event.preventDefault();
              // Move to next visible tier, wrap to first if at end
              targetTier = visibleTiers[currentIndex + 1] || visibleTiers[0];
            } else if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
              event.preventDefault();
              // Move to previous visible tier, wrap to last if at start
              targetTier = visibleTiers[currentIndex - 1] || visibleTiers[visibleTiers.length - 1];
            } else if (event.key === 'Home') {
              event.preventDefault();
              // Move to first visible tier
              targetTier = visibleTiers[0];
            } else if (event.key === 'End') {
              event.preventDefault();
              // Move to last visible tier
              targetTier = visibleTiers[visibleTiers.length - 1];
            }
            
            // If we have a target tier, move focus and select it
            if (targetTier) {
              targetTier.focus();
              this.selectTier(targetTier);
            }
          }
        
          /**
           * Selects a tier and updates quantity input
           * 
           * Implements the roving tabindex pattern for keyboard navigation:
           * - Only the selected tier has tabindex="0" (in tab order)
           * - All other tiers have tabindex="-1" (not in tab order)
           * - This ensures proper keyboard navigation while maintaining accessibility
           * 
           * @param {HTMLElement} selectedTier - The tier element to select
           */
          selectTier(selectedTier) {
            // Query fresh tier elements to ensure consistency with handleVariantChange
            // This prevents issues if tiers are dynamically added/removed
            const allTiers = this.querySelectorAll('.volume-pricing-tier');
            
            for (const tier of allTiers) {
              tier.classList.remove('is-selected');
              tier.setAttribute('aria-checked', 'false');
              // Update tabindex: only selected tier is in tab order (roving tabindex pattern)
              tier.setAttribute('tabindex', '-1');
            }
            
            selectedTier.classList.add('is-selected');
            selectedTier.setAttribute('aria-checked', 'true');
            selectedTier.setAttribute('tabindex', '0');
            
            const quantity = selectedTier.dataset.quantity;
            
            if (this.debug) {
              console.log('[Volume Discount] Tier selected:', {
                quantity,
                tierElement: selectedTier
              });
            }
            
            const quantityInput = this.findQuantityInput();
            
            if (quantityInput) {
              quantityInput.value = quantity;
              
              /**
               * Manage max attribute on quantity input based on inventory policy
               * - If backorders are allowed: remove max to allow any quantity
               * - If inventory is tracked and backorders not allowed: set max to available stock
               * 
               * Try multiple locations to find variant-picker (works with both radio button and dropdown selectors)
               */
              let variantPicker = this.section?.querySelector('variant-picker');
              if (!variantPicker) {
                variantPicker = this.closest('.js-product')?.querySelector('variant-picker');
              }
              if (!variantPicker) {
                variantPicker = document.querySelector('variant-picker');
              }
              const currentVariant = variantPicker?.variant;
              
              if (currentVariant) {
                const canSellOutOfStock = currentVariant.inventory_policy === 'continue';
                if (canSellOutOfStock) {
                  // Remove max attribute to allow any quantity when backorders are allowed
                  quantityInput.removeAttribute('max');
                  if (this.debug) {
                    console.log('[Volume Discount] Backorders allowed - removed max attribute from quantity input');
                  }
                } else if (currentVariant.inventory_management && currentVariant.inventory_policy === 'deny') {
                  // Set max to inventory quantity if inventory is tracked and backorders not allowed
                  const maxQty = currentVariant.inventory_quantity || 0;
                  if (maxQty > 0) {
                    quantityInput.setAttribute('max', maxQty);
                  } else {
                    quantityInput.removeAttribute('max');
                  }
                }
              }
              
              quantityInput.dispatchEvent(new Event('input', { bubbles: true }));
              quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
              if (this.debug) {
                console.log('[Volume Discount] Updated quantity input:', {
                  quantity,
                  inputId: quantityInput.id,
                  inputName: quantityInput.name,
                  maxAttribute: quantityInput.getAttribute('max'),
                  canSellOutOfStock: currentVariant?.inventory_policy === 'continue'
                });
              }
            } else {
              if (this.debug) {
                console.warn('[Volume Discount] Quantity input not found. Tried selectors:', {
                  sectionSpecific: sectionId ? `#Quantity-${sectionId}` : 'N/A',
                  simpleId: '#quantity',
                  nameAttribute: 'input[name="quantity"]'
                });
              }
            }
            
            const eventDetail = { quantity: parseInt(quantity, 10) };
            
            if (this.debug) {
              console.log('[Volume Discount] Dispatching tier-selected event:', eventDetail);
            }
            
            this.dispatchEvent(new CustomEvent('volume-pricing:tier-selected', {
              bubbles: true,
              detail: eventDetail
            }));
          }
        }
      );
    }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["sleeknote-popup"] && !Shopify.designMode) return;
  try {
    class SleeknotePopup extends HTMLElement {
  constructor() {
    super();
    
    this.liquidEligible = this.dataset.liquidEligible;
    this.campaignCodeCheck = this.dataset.campaignCodeCheck;
    this.bundleBadgeCheck = this.dataset.bundleBadgeCheck;
    this.disallowedUtmValues = this.dataset.disallowedUtmValues;
    this.delay = this.dataset.delay;
    this.sleeknoteId = this.dataset.sleeknoteId;
    this.limitPerSession = parseInt(this.dataset.limitPerSession);
    
    try {
      this.disallowedUtmValues = JSON.parse(this.disallowedUtmValues);
    } catch (err) {
      this.disallowedUtmValues = [this.disallowedUtmValues];
    }    
  }
  
  connectedCallback() {    
    this.triggeredCount = parseInt(sessionStorage.getItem(`${this.sleeknoteId}_triggered`)) || 0;
        
    if (this.checkEligibility()) {      
      setTimeout(() => {
        if (this.triggeredCount < this.limitPerSession) {
          this.triggerSleekNotePopup();
        }
      }, this.delay * 1000);
    }
  }
  
  disconnectedCallback() {}
  
  checkEligibility() {
    let isEligible = this.liquidEligible;

    if (this.campaignCodeCheck) {
      const campaignCodeEl = document.querySelector('[data-copy].dynamic-campaign-code');
      if (campaignCodeEl) isEligible = false;
    }
    
    if (this.bundleBadgeCheck) {
      const bundleBadgeEl = document.querySelector('.bundle-badge');
      if (bundleBadgeEl) isEligible = false;
    }
    
    if (this.disallowedUtmValues) {
      const utmParams = new URLSearchParams(window.location.search);
      if (utmParams.has('utm_source')) {
        const utmSource = utmParams.get('utm_source');
        for (const disallowedUtmValue of this.disallowedUtmValues) {
          if (utmSource == disallowedUtmValue) { 
            isEligible = false;
          }
        }
      }
    }
    
    return isEligible;
  }
  
  loadSleekNoteScript() {
    return new Promise((resolve, reject) => {
      if (window.SleekNote) {
        resolve(window.SleekNote);
      }
      
      const script = document.createElement('script');
      script.type = 'text/javascript';
      script.charset = 'utf-8';
      script.src = '//sleeknotecustomerscripts.sleeknote.com/31.js';
      
      script.onload = () => {
        if (window.SleekNote?.triggerOnClick) {
          resolve(window.SleekNote);
        } else {
          reject(new Error('SleekNote failed to initialize'));
        }
      };
      
      script.onerror = () => {
        reject(new Error('Failed to load SleekNote script'));
      };
      
      const currentScript = document.getElementById('sleeknoteScript');
      currentScript.parentNode.insertBefore(script, currentScript);
    });
  }
  
  async triggerSleekNotePopup() {
    try {
      const sleekNote = await this.loadSleekNoteScript();
      sleekNote.triggerOnClick(this.sleeknoteId);
      sessionStorage.setItem(`${this.sleeknoteId}_triggered`, this.triggeredCount + 1);
      
      console.log('SleekNote popup triggered', this.sleeknoteId);
    } catch (error) {
      console.warn('SleekNote popup failed to load:', error.message);
    }
  };
}

customElements.define('sleeknote-popup', SleeknotePopup);
  } catch(e) { console.error(e); }
})();

})();
